/**
 * servicing eapi
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

/**
 * 払込詳細<br/> 次アクションの払込がtrueの場合のみ返却する。
 */
export interface GetOrderResponseDataNextActionsOfflinePaymentDetails {
  /**
   * 購入期限(yyyy-MM-ddTHH:mm:ss形式)<br/> ※data.paymentRecords.paymentTransaction.paymentMethodのparametersの4番目に返却される購入期限(yyyyMMddHHmmSS形式)を操作オフィスのタイムゾーンに変換する
   */
  deadline?: string;
  /**
   * 購入期限を超過しているか<br/> 購入期限と現在時刻を比較し、現在時刻の方が後である場合true
   */
  isExpired?: boolean;
  /**
   * 支払方法<br/> convinienceStore：コンビニ支払<br/> bank：インターネットバンキング
   */
  paymentMethod?: GetOrderResponseDataNextActionsOfflinePaymentDetails.PaymentMethodEnum;
  /**
   * 銀行コード<br/> ※ FPのフリーテキストの内容をDxAPIが文字列解析したものが返却され、支払方法がインターネットバンキングの場合解析されたパラメータの2番目に銀行コードが返却されるため、その内容を返却する。
   */
  bankCode?: string;
  /**
   * 決済番号<br/> ※ FPのフリーテキストの内容をDxAPIが文字列解析したものが返却され、支払方法がコンビニ支払の場合解析されたパラメータの2番目に決済番号が返却されるため、その内容を返却する。
   */
  paymentNumber?: string;
  /**
   * 暗号化済み決済番号
   */
  encryptedPaymentNumber?: string;
}
export namespace GetOrderResponseDataNextActionsOfflinePaymentDetails {
  export type PaymentMethodEnum = 'convinienceStore' | 'bank' | 'payeasy';
  export const PaymentMethodEnum = {
    ConvinienceStore: 'convinienceStore' as PaymentMethodEnum,
    Bank: 'bank' as PaymentMethodEnum,
    Payeasy: 'payeasy' as PaymentMethodEnum,
  };
}
